import { render } from "./VacancyPreviewModal.vue?vue&type=template&id=49dfa2ec&scoped=true"
import script from "./VacancyPreviewModal.vue?vue&type=script&lang=js"
export * from "./VacancyPreviewModal.vue?vue&type=script&lang=js"

import "./VacancyPreviewModal.vue?vue&type=style&index=0&id=49dfa2ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49dfa2ec"]])

export default __exports__